<div *ngIf="tutor" class="d-flex flex-column justify-content-center align-items-center h-100">

    <!-- Alerts -->
    <div class="w-100 mb-3">

        <div *ngIf="showSuccessMessage" class="alert alert-success w-100 m-0">
            {{successMessage}}
        </div>

        <div *ngIf="showErrorMessage" class="alert alert-danger w-100 m-0" role="alert">
            {{ errorMessage }}
        </div>

    </div>

    <!-- Tutor data -->
    <div class="d-flex flex-column justify-content-center align-content-start h-100 w-100">

        <div class="row mb-2">

            <!-- NIF/NIE -->
            <div class="col-12 col-md-6">
                <div class="d-flex flex-column justify-content-center align-items-start w-100">
                    <span class="text-primary-color fw-bolder" [appAsterisk]="true">DNI/NIE</span>
                    <input type="text" pInputText class="w-100" [(ngModel)]="tutor.dni"/>
                </div>
            </div>

            <!-- Correo electrónico -->
            <div class="col-12 col-md-6">
                <div class="d-flex flex-column justify-content-center align-items-start w-100">
                    <span class="text-primary-color fw-bolder" [appAsterisk]="true">Correo electrónico</span>
                    <input type="text" pInputText class="w-100" [(ngModel)]="tutor.mail" (ngModelChange)="onEmailChange()"/>
                    <small *ngIf="!isValidEmail" class="text-danger-color" >{{emailValidationError}}</small>
                </div>
            </div>

        </div>

        <div class="row mb-2">

            <!-- Nombre -->
            <div class="col-12 col-md-6">
                <div class="d-flex flex-column justify-content-center align-items-start w-100">
                    <span class="text-primary-color fw-bolder" [appAsterisk]="true">Nombre</span>
                    <input type="text" pInputText class="w-100" [(ngModel)]="tutor.name"/>
                </div>
            </div>

            <!-- Apellidos -->
            <div class="col-12 col-md-6">
                <div class="d-flex flex-column justify-content-center align-items-start w-100">
                    <span class="text-primary-color fw-bolder" [appAsterisk]="true">Apellidos</span>
                    <input type="text" pInputText class="w-100" [(ngModel)]="tutor.surname"/>
                </div>
            </div>

        </div>

        <div class="row mb-2">

            <!-- Teléfono 1 -->
            <div class="col-12 col-md-6">
                <div class="d-flex flex-column justify-content-center align-items-start w-100">
                    <span class="text-primary-color fw-bolder" [appAsterisk]="true">Teléfono 1</span>
                    <input type="text" pInputText class="w-100" [(ngModel)]="tutor.phone1"/>
                </div>
            </div>

            <!-- Teléfono 2 -->
            <div class="col-12 col-md-6">
                <div class="d-flex flex-column justify-content-center align-items-start w-100">
                    <span class="text-primary-color fw-bolder">Teléfono 2</span>
                    <input type="text" pInputText class="w-100" [(ngModel)]="tutor.phone2"/>
                </div>
            </div>

        </div>

    </div>

    <!-- Password -->
    <div class="d-flex flex-column justify-content-center align-content-start h-100 w-100 my-2">

        <div class="alert alert-info" role="alert">
            <span class="fw-bolder"> Para cambiar la contraseña debe rellenar los siguientes campos:</span>
        </div>

        <div class="row mb-2">

            <div class="col-12 col-lg-6">
                <div class="d-flex flex-column justify-content-center align-items-start w-100">
                    <span class="text-primary-color fw-bolder" [appAsterisk]="true">Contraseña</span>
                    <input type="password" pInputText class="w-100" [(ngModel)]="tutor.password" (ngModelChange)="onPasswordChange()"/>
                    <small *ngIf="!isValidPassword" class="text-danger-color" >{{passwordValidationError}}</small>
                </div>
            </div>

            <div class="col-12 col-lg-6">
                <div class="d-flex flex-column justify-content-center align-items-start w-100">
                    <span class="text-primary-color fw-bolder" [appAsterisk]="true">Confirmar contraseña</span>
                    <input type="password" pInputText class="w-100" [(ngModel)]="tutorPasswordConfirmation" (ngModelChange)="onPasswordConfirmationChange()"/>
                    <small *ngIf="!isValidPasswordConfirmation" class="text-danger-color" >{{passwordConfirmationValidationError}}</small>
                </div>
            </div>

        </div>

    </div>

    <!-- Button -->
    <div class="d-flex flex-column justify-content-center align-content-start h-100 w-100 my-2">

        <div class="row">

            <div class="col-12">

                <div class="d-flex flex-column justify-content-center align-items-start w-100">

                    <button type="button" class="btn button-accent-color w-100 py-2"
                        [disabled]="!isFormValid() || isProcessing"
                        (click)="updateTutor()">

                        <div *ngIf="!isProcessing" class="w-100">
                            <span class="fs-6">Modificar usuario</span>
                        </div>

                        <div *ngIf="isProcessing" class="d-flex flex-row justify-content-center align-items-center w-100">
                            <fa-icon [icon]="['fas', 'spinner']" [spin]="true"></fa-icon>
                        </div>

                    </button>

                </div>

            </div>

        </div>

    </div>

</div>
